import React, { useEffect, useState } from 'react';
import { Icon } from 'leaflet';
import { TileLayer, Marker, Popup } from 'react-leaflet';
import markerIconPng from 'leaflet/dist/images/marker-icon.png';
import Geocode from 'react-geocode';
import * as S from './Map.styled';
import { geocodeKey } from '~/utils/keys';

Geocode.setApiKey(geocodeKey);
Geocode.setLanguage('cs');
Geocode.setRegion('br');

function MapContainer({ rua, numero, bairro, cidade, corFonte }) {
  const discardCompleFromRua = rua?.split('-')[0];
  let query = `${discardCompleFromRua || ' '} ${numero || ''} ${bairro ||
    ''} ${cidade || ''}`;
  query = query.replace(/\s/g, '+');

  function redirect() {
    window.open(`https://www.google.com/maps/search/?api=1&query=${query}`);
  }

  const [data, setData] = useState(false);
  const [isMapActive, setIsMapActive] = useState(false);
  const [hasLoadedGeolocation, setHasLoadedGeolocation] = useState(false);

  const activateMap = () => {
    setIsMapActive(true);
    
    // Só chama a API do Google quando o mapa for ativado
    if (!hasLoadedGeolocation) {
      setHasLoadedGeolocation(true);
      Geocode.fromAddress(
        `${discardCompleFromRua || ' '} ${bairro || ' '} ${cidade || ' '}`
      ).then(
        response => {
          setData(response.results[0].geometry.location);
        },
        error => {
          setData(null);
        }
      );
    }
  };

  // Remove o useEffect que carregava automaticamente
  // useEffect(() => {
  //   Geocode.fromAddress(
  //     `${discardCompleFromRua || ' '} ${bairro || ' '} ${cidade || ' '}`
  //   ).then(
  //     response => {
  //       setData(response.results[0].geometry.location);
  //     },
  //     error => {
  //       setData(null);
  //     }
  //   );
  // }, []);

  const loadMap = () => {
    // Se o mapa não foi ativado ainda, mostra o mapa "preview" com overlay
    if (!isMapActive) {
      return (
        <S.MapContainer>
          {/* Mapa de fundo estático (sem interação) */}
          <S.Map 
            center={[-15.8267, -47.9218]} // Coordenadas padrão de Brasília
            zoom={13}
            zoomControl={false}
            scrollWheelZoom={false}
            doubleClickZoom={false}
            touchZoom={false}
            dragging={false}
            keyboard={false}
            boxZoom={false}
          >
            <TileLayer
              attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
          </S.Map>
          
          {/* Overlay clicável para ativar o mapa */}
          <S.MapOverlay onClick={activateMap}>
            <S.OverlayContent>
              <S.OverlayIcon />
              <S.OverlayTitle>Visualizar Mapa</S.OverlayTitle>
              <S.OverlayText>Clique para ativar o mapa interativo</S.OverlayText>
            </S.OverlayContent>
          </S.MapOverlay>
        </S.MapContainer>
      );
    }

    // Mapa ativo - comportamento original
    if (data) {
      return (
        <S.MapContainer>
          <S.Map center={data} zoom={17}>
            <TileLayer
              attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker
              position={data}
              icon={
                new Icon({
                  iconUrl: markerIconPng,
                  iconSize: [25, 41],
                  iconAnchor: [13, 40],
                })
              }
            >
              <S.PopupStyles />
              <Popup>
                <S.PopupLink onClick={redirect}>
                  {rua}
                </S.PopupLink>
              </Popup>
            </Marker>
          </S.Map>
        </S.MapContainer>
      );
    }

    if (data === null) {
      return <S.MapTextCard>Localização não encontrada.</S.MapTextCard>;
    }

    return <S.MapTextCard>Carregando localização...</S.MapTextCard>;
  };

  return <>{loadMap()}</>;
}

export default MapContainer;
